import { Marker } from '@react-google-maps/api'
import React, { useCallback, useMemo } from 'react'
import { VendorFragment } from '../../src/model/fragments'

export interface VendorMarkerProps {
	place: VendorFragment
	isSelected: boolean
	onClick: (place: VendorFragment) => void
}

export const VendorMarker: React.FC<VendorMarkerProps> = ({
	place,
	isSelected,
	onClick,
}) => {
	const onClickInner = useCallback(() => onClick(place), [onClick, place])
	const position = useMemo(
		() => ({ lat: place.gpsLat!, lng: place.gpsLng! }),
		[place],
	)
	const icon = useMemo(() => {
		const iconBaseName =
			place.type === 'store'
				? 'marker-wrench'
				: place.type === 'showroom'
				? 'marker-bulb'
				: place.type === 'dealer'
				? 'marker-cart'
				: 'marker'
		const url = isSelected
			? `/${iconBaseName}-active.svg`
			: `/${iconBaseName}.svg`
		return {
			url,
			anchor: new google.maps.Point(18, 55),
		}
	}, [isSelected, place.type])
	if (!place.gpsLat || !place.gpsLng) {
		return null
	}

	return <Marker position={position} icon={icon} onClick={onClickInner} />
}
